<template>
  <div :class="show ? 'selectInput ' : 'selectInput'" ref="containerss">
    <div class="selectInput-one" @click="show = !show">
      <div :class="show ? 'xuanz' : ''">
        <img src="@/assets/images/h5/icon5.png" alt="" />
      </div>
      <input
        type="text"
        readonly
        ref="inputs"
        :placeholder="placeholder"
        @blur="inputBlur($event)"
        v-bind:value="model == 'array' ? value : setValue(value)"
      />
    </div>
    <div v-show="stateShow" class="selectInput-three">
      <span>{{ stateTitle }}</span>
    </div>
    <div class="selectInput-two" v-show="show">
      <ul v-if="model == 'array' && dataList.length > 0">
        <li
          v-for="(item, index) in dataList"
          :key="index"
          :class="index === indexClass ? 'fontactive' : ''"
          @touchstart="checked(item, index)"
        >
          {{ item }}
        </li>
      </ul>
      <ul v-if="model == 'json' && dataList.length > 0">
        <li
          v-for="(item, index) in dataList"
          :key="index"
          :class="index === indexClass ? 'fontactive' : ''"
          :style="{ background: noxuan ? '#ffffff' : '#fafafa' }"
          @touchstart="checked(item, index)"
        >
          {{ setValue(item) }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  // placeholder:提示
  // model:数据类型（array，json）
  // selname:显示的内容名称(model为array可以不传)
  //dataList：数据
  props: ["placeholder", "model", "selname", "dataList", "stateTitle"],
  data() {
    return {
      show: false,
      value: "",
      indexClass: null,
      noxuan: true,
      stateShow: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.otherClose);
  },
  methods: {
    // 失去焦点
    inputBlur(e) {
      if (this.noxuan == false) {
        this.$refs["inputs"].style.borderColor = "#cccccc";
        this.stateShow = false;
        return;
      }
      if (!e.target.value) {
        this.$refs["inputs"].style.borderColor = "red";
        this.stateShow = true;
      } else {
        this.$refs["inputs"].style.borderColor = "#cccccc";
        this.stateShow = false;
      }
    },
    otherClose(e) {
      if (!this.$refs.containerss.contains(e.target)) this.show = false;
    },
    setValue(val) {
      let arr = val;
      const map = new Map(Object.entries(arr));
      return map.get(this.selname);
    },
    checked(val, index) {
      if (this.indexClass === index) return;
      if (this.noxuan == false) return;
      this.indexClass = index;
      this.show = false;
      this.value = val;
      this.$emit("changValue", val);
    },
    resetValue() {
      this.value = "";
      this.indexClass = null;
    },
    setbag(val) {
      this.noxuan = val;
    },
    setinputstate() {
      this.$refs["inputs"].style.borderColor = "red";
      this.stateShow = true;
    },
  },
  beforeDestroy() {
    /* 组件销毁的时候要移除侦听器 */
    window.removeEventListener("click", this.otherClose);
  },
};
</script>
<style lang="scss" scoped>
.selectInput {
  width: 100%;
  height: auto;
  position: relative;
  // border: 1px solid #cccccc;
  // border-radius: 0.18rem;
  &-one {
    position: relative;
    width: 100%;
    height: 0.37rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    input {
      width: 100%;
      height: 100%;
      background-color: transparent;
      border: 1px solid #cccccc;
      outline: none;
      border-radius: 0.18rem;
      font-size: 0.1rem;
      font-weight: 400;
      color: #444444;
      text-indent: 0.1rem;
      box-sizing: border-box;
      &::-webkit-input-placeholder {
        color: #cccccc;
      }
      &::-moz-input-placeholder {
        color: #cccccc;
      }
      &::-ms-input-placeholder {
        color: #cccccc;
      }
      &:focus {
        border-color: #50bbe5 !important;
      }
    }
    span {
      margin-left: 0.1rem;
      font-size: 0.1rem;
      font-weight: 400;
      // color: #cccccc;
      color: #444444;
    }
    div {
      position: absolute;
      right: 0;
      top: 50%;
      width: 0.15rem;
      height: 0.15rem;
      transform: translateY(-50%);
      margin-right: 0.05rem;
      background: #50bbe5;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        transition: all 0.2s;
      }
    }
    .xuanz {
      > img {
        transform: rotate(90deg);
      }
    }
  }
  &.bor {
    border: 1px solid #50bbe5;
  }
  &-three {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 0.1rem;
    color: red;
    margin-top: 0.42rem;
  }
  &-two {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: auto;
    max-height: 1.2rem;
    margin-top: 0.4rem;
    border-radius: 0.2rem;
    box-shadow: 0 0.06rem 0.1rem rgba(0, 0, 0, 0.2);
    overflow: hidden;
    overflow-y: scroll;
    transition: all 0.2s;
    background: white;
    ul {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #fff;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      li {
        position: relative;
        padding: 0 0.12rem;
        height: 0.3rem;
        color: #444444;
        line-height: 0.3rem;
        font-size: 0.12rem;
        margin-top: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        list-style-type: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        &.fontactive {
          color: #50bbe5;
        }
      }
    }
  }
}
</style>
